// +----------------------------------------------------------------------
// | 路由表
// | 公开：/login /register /decision/share/:token /topics*
// | 其余在 Layout 内，其中需要登录的用 <RequireAuth> 包一层
// +----------------------------------------------------------------------
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import useAuth from './hooks/useAuth';

import Home from './view/Home';
import Login from './view/Login';
import Register from './view/Register';
import Decision from './view/Decision';
import DecisionDetail from './view/DecisionDetail';
import DecisionHistory from './view/DecisionHistory';
import DecisionShare from './view/DecisionShare';
import Profile from './view/Profile';
import Settings from './view/Settings';
import Memories from './view/Memories';
import Topics from './view/Topics';
import TopicDetail from './view/TopicDetail';
import Chat from './view/Chat';
import NotFound from './view/NotFound';

function LayoutShell() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function RequireAuth({ children }) {
  const { isLoggedIn, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return <div className="page center muted">正在加载…</div>;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* 免登录页面 */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/decision/share/:token" element={<DecisionShare />} />

      {/* 主站（带顶部导航） */}
      <Route element={<LayoutShell />}>
        <Route path="/" element={<Home />} />

        {/* 热门纠结：公共数据，免登录也能看 */}
        <Route path="/topics" element={<Topics />} />
        <Route path="/topics/:key" element={<TopicDetail />} />

        {/* AI 对话（Phase 9）：/chat 是新对话，/chat/:id 是某个会话 */}
        <Route
          path="/chat"
          element={
            <RequireAuth>
              <Chat />
            </RequireAuth>
          }
        />
        <Route
          path="/chat/:id"
          element={
            <RequireAuth>
              <Chat />
            </RequireAuth>
          }
        />

        <Route
          path="/decision/:id"
          element={
            <RequireAuth>
              <Decision />
            </RequireAuth>
          }
        />
        <Route
          path="/decision/:id/result"
          element={
            <RequireAuth>
              <DecisionDetail />
            </RequireAuth>
          }
        />
        <Route
          path="/history"
          element={
            <RequireAuth>
              <DecisionHistory />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <Settings />
            </RequireAuth>
          }
        />
        <Route
          path="/memories"
          element={
            <RequireAuth>
              <Memories />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
